import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=0baa8bd8&scoped=true&"
import script from "./list2.vue?vue&type=script&lang=ts&"
export * from "./list2.vue?vue&type=script&lang=ts&"
import style0 from "./list2.vue?vue&type=style&index=0&id=0baa8bd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa8bd8",
  null
  
)

export default component.exports